type DownloadOptions = {
  url: string;
  fileName?: string;
  mimeType?: string;
  onSuccess?: () => void;
  onError?: (error: unknown) => void;
};

export const downloadFile = async ({
  url,
  fileName,
  mimeType,
  onSuccess,
  onError,
}: DownloadOptions) => {
  if (!url) return;

  try {
    // Fetch file
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Failed to fetch file: ${response.status}`);
    }

    const blob = await response.blob();

    // Resolve mime type
    const resolvedMimeType =
      mimeType || blob.type || 'application/octet-stream';

    // Resolve extension
    let extension = 'file';
    if (resolvedMimeType.includes('pdf')) extension = 'pdf';
    else if (resolvedMimeType.includes('zip')) extension = 'zip';
    else if (resolvedMimeType.includes('image')) {
      extension = resolvedMimeType.split('/')[1];
    } else {
      const match = resolvedMimeType.match(/\/(\w+)$/);
      if (match) extension = match[1];
    }

    // Clean filename
    const baseName = (fileName || 'download')
      .replace(/[^\w\s.-]/gi, '_')
      .replace(/\s+/g, '_');

    const finalFileName = baseName.includes('.')
      ? baseName
      : `${baseName}.${extension}`;

    // Create File
    const file = new File([blob], finalFileName, {
      type: resolvedMimeType,
    });

    // Create object URL
    const urlObj = URL.createObjectURL(file);

    // Trigger download
    const link = document.createElement('a');
    link.href = urlObj;
    link.download = finalFileName;
    document.body.appendChild(link);
    link.click();

    // Cleanup
    document.body.removeChild(link);
    URL.revokeObjectURL(urlObj);

    onSuccess?.();
  } catch (error) {
    console.error('Download failed:', error);
    onError?.(error);
  }
};
